<template>
  <div class="row form-container justify-content-center">
    <div class="col-12 col-md-10 col-lg-10 col-xl-10">
      <step-back-button v-if="canGoPrevious" @click="this.onPrevious"/>
      <transition v-bind:name="transitionName" mode='out-in'>
        <component v-if="investor" :is='currentStepComponent' :investor="investor" @submit="this.updateInvestor"></component>
      </transition>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import ApiClient from '../utils/api-client'
  import steps from '@/components/AdditionalInformationInvestor'
  import * as mutationTypes from '@/store/mutation-types.js'
  import ArrayHelper from '@/utils/array-helper'
  import StepBackButton from '@/components/StepBackButton'
  import HubConsultaClient from '../utils/hub-consulta-client.js'

  let components = Object.assign({StepBackButton}, steps)

  export default {
    data() {
      return {
        transitionName: 'slide-left',
        investor: null
      }
    },
    components: components,
    computed: {
      currentStepComponent() {
        const stepNames = Object.keys(steps)
        const currentStatus = this.investor ? this.investor.Status : null
        return stepNames.includes(currentStatus) ? currentStatus : stepNames[0]
      },
      progress() {
        const stepsAmount = Object.keys(steps).length
        const currentStepNumber = Object.keys(steps).indexOf(this.currentStepComponent) + 1
        return Math.round( (currentStepNumber * 100) / stepsAmount )
      },
      canGoPrevious() {
        if(!this.investor) return false

        const stepsThatCantGoBack = ['informacoes-pessoais', 'cadastro-concluido']
        return !stepsThatCantGoBack.includes(this.investor.Status)
      }
    },
    methods: {
      updateInvestor(data) {
        this.transitionName = 'slide-left'

        this.$store.commit(mutationTypes.START_LOADING)
        ApiClient.updateInvestorInformation('next', data)
          .then((investor) => {this.investor = investor;

          //TASK: Automatizar Consultas de Cadastro de Investidores (Clickup - 24/09)
          // Roda após obter cpf e data de nascimento
           if(investor.Status == "endereco")
           {
              HubConsultaClient.ConsultaInvestidor(this.$store.state.currentUser.email)
           }


          this.atualizarUser(investor.Status)
          this.$store.commit(mutationTypes.STOP_LOADING)}
          ).catch(error => {
            const errorMessages = error.response ? error.response.data.errors.map(error => error.detail) : error.message
            this.$Notify.error(ArrayHelper.toSentence(errorMessages))
             this.$store.commit(mutationTypes.STOP_LOADING)
          })

      },
      atualizarUser(stepAtual)
      {
         if(stepAtual == "cadastro-concluido"){


              ApiClient.updateUserInvestor().then(()=>{

                this.$store.commit(mutationTypes.STOP_LOADING);

                this.$store.dispatch('updateUser')
                        .then()
                        .catch(error => {
                            const errorMessages = error.response.data.errors.map(error => error.detail)
                            this.$Notify.error(ArrayHelper.toSentence(errorMessages))
                        })
                }
              ).catch(error => {
                const errorMessages = error.response ? error.response.data.errors.map(error => error.detail) : error.message
                this.$Notify.error(ArrayHelper.toSentence(errorMessages))
                this.$store.commit(mutationTypes.STOP_LOADING)
              })

              // ATUALIZA TAG NO ACTIVE CAMPAIN ...
              HubConsultaClient.AtualizarActive(this.$store.state.currentUser.email, "usuario-suitability-incompleto")
              .then()
              .catch()

          }
      },
      onPrevious() {
        this.transitionName = 'slide-right'

        this.$store.commit(mutationTypes.START_LOADING)
        ApiClient.updateInvestorInformation('previous', {})
          .then(investor => {this.investor = investor;    this.$store.commit(mutationTypes.STOP_LOADING)})

      }
    },
    beforeCreate() {
      this.investorId = this.$route.params.id

      this.$store.commit(mutationTypes.START_LOADING)
      ApiClient.getInvestor()
        .then(investor => {
          this.investor = investor;
             this.$store.commit(mutationTypes.STOP_LOADING)

        }).catch(() => this.$store.commit(mutationTypes.STOP_LOADING))

    },
    beforeUpdate() {
      this.$Loading.update(this.progress)
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/AdditionalInformationInvestor.vue